import React from "react";
import CourseAsideHero from "../../../reusable/CourseAsideHero";
import {
  BANKING_DETAILS_PAGE_1,
  BANKING_HERO_PAGE_1,
  BANKING_COURSE_PAGE_1,
  BANKING_BOTTOM_CONTENT,
} from "../../../utils/constants";
import CourseCard from "../../../reusable/Course-card";
import CoursesAside from "../../../reusable/Aside-courses";
import { BANKING_ACCORDIAN_1 } from "../../../utils/courseConifg";
import Accordian from "../../../reusable/Accordian";
import PageDesc from "../../../reusable/PageDesc";

const BankingPage_1 = () => {
  return (
    <div className="outlet-render">
      <CourseAsideHero {...BANKING_HERO_PAGE_1} />
      <CoursesAside {...BANKING_COURSE_PAGE_1} />
        <CourseCard {...BANKING_DETAILS_PAGE_1}/>
      <Accordian {...BANKING_ACCORDIAN_1}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT} />
    </div>
  );
};

export default BankingPage_1;
